import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CheckoutAddresssComponentDef } from '@df/checkout/checkout-address.component.def';
import { RadioGroupDirective } from '@df/ui/form/radio/radio.component.def';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { AddressShortComponent } from '../../ui/display/address-short/address-short.component';
import { AddressFieldsetComponent } from '../../ui/form/address-fieldset.component';
import { CheckboxComponent } from '../../ui/form/checkbox';
import { InputWrapBodyDirective } from '../../ui/form/input-wrap-body.directive';
import { InputWrapComponent } from '../../ui/form/input-wrap.component';
import { RadioComponent } from '../../ui/form/radio/radio.component';
@Component({
    selector: 'checkout-address',
    templateUrl: './checkout-address.html',
    standalone: true,
    imports: [
        FormsModule,
        CommonModule,
        InputWrapComponent,
        AddressFieldsetComponent,
        TranslationModule,
        RadioComponent,
        AddressShortComponent,
        RadioGroupDirective,
        CheckboxComponent,
        InputWrapBodyDirective
    ]
})
export class CheckoutAddresssComponent extends CheckoutAddresssComponentDef {
    private ref = inject(ChangeDetectorRef);

    detectChanges(): void {
        this.ref.detectChanges();
    }
}
